/** Modern SVG-based default avatar. Used consistently across chat, map, and profile. */
export function DefaultAvatar({ gender, size = 20 }: { gender: 'male' | 'female' | 'unknown'; size?: number }) {
  const color = gender === 'male' ? '#4a9eff' : gender === 'female' ? '#ff6b9d' : '#aaa';
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="9" r="4" fill={color} opacity="0.9" />
      <path d="M4 21c0-4 3.5-7 8-7s8 3 8 7" fill={color} opacity="0.7" />
    </svg>
  );
}
